import React from "react";
import DoctorPersonalDetailsForm from "./personaldetails/DoctorPersonalDetailsForm";
import DoctorBusinessDetailsForm from "./businessdetails/DoctorBusinessDetailsForm";
import DoctorContactDetailsForm from "./contactdetails/DoctorContactDetailsForm";
import DoctorPhotogalleryForm from "./photogallery/DoctorPhotogalleryForm";

import PhotographerPersonalDetailsForm from "./personaldetails/PhotographerPersonalDetailsForm";
import PhotographerBusinessDetailsForm from "./businessdetails/PhotographerBusinessDetailsForm";
import PhotographerContactDetailsForm from "./contactdetails/PhotographerContactDetailsForm";
import PhotographerPhotogalleryForm from "./photogallery/PhotographerPhotogalleryForm";
import AgriculturePersonalDetailsForm from "./personaldetails/AgriculturePersonalDetailsForm";
import AgricultureBusinessDetailsForm from "./businessdetails/AgricultureBusinessDetailsForm";
import AgricultureContactDetailsForm from "./contactdetails/AgricultureContactDetailsForm";
import AgriculturePhotogalleryForm from "./photogallery/AgriculturePhotogalleryForm";
import BeautyParlourPersonalDetailsForm from "./personaldetails/BeautyParlourPersonalDetailsForm";
import BeautyParlourBusinessDetailsForm from "./businessdetails/BeautyParlourBusinessDetailsForm";
import BeautyParlourContactDetailsForm from "./contactdetails/BeautyParlourContactDetailsForm";
import BeautyParlourPhotogalleryForm from "./photogallery/BeautyParlourPhotogalleryForm";

const formMap = {
  'agriculture': {
    personal: AgriculturePersonalDetailsForm,
    business: AgricultureBusinessDetailsForm,
    contact: AgricultureContactDetailsForm,
    gallery: AgriculturePhotogalleryForm

  },
  'beauty parlour': {
     personal: BeautyParlourPersonalDetailsForm,
     business: BeautyParlourBusinessDetailsForm,
     contact: BeautyParlourContactDetailsForm,
     gallery: BeautyParlourPhotogalleryForm
   },
  'doctors': {
    personal: DoctorPersonalDetailsForm,
    business: DoctorBusinessDetailsForm,
    contact: DoctorContactDetailsForm,
    gallery: DoctorPhotogalleryForm
  },
  'photographers': {
    personal: PhotographerPersonalDetailsForm,
    business: PhotographerBusinessDetailsForm,
    contact: PhotographerContactDetailsForm,
    gallery: PhotographerPhotogalleryForm
  }
};

function RenderForm({ session, type }) {
  const category = session?.ucategory?.toLowerCase();

  const FormComponent = formMap?.[category]?.[type];

  return FormComponent ? <FormComponent /> : <div>No form available</div>;
}

export default RenderForm;